<template>
  <div class="pt-1">
    <div class="container-fluid">
      <h3 class="pl-3 mt-0 mb-3 text-title-dashboard my-2 font-weight-bold">
        Empresa Agremiada
      </h3>
      <div class="row">
        <!-- password card start -->
        <div class="col-xl-3">
          <div class="card pt-2">
            <div class="card-header p-2 border-bottom">
              <h4 class="m-0 text-center font-weight-normal">
                Datos del usuario
              </h4>
            </div>
            <div class="card-body row">
              <div
                class="col-xl-12 col-md-4 col-12 d-flex justify-content-center align-items-center"
              >
                <img
                  v-if="
                    form_user.url_image &&
                    (form_user.url_image !== '') ^
                      (form_user.url_image !== 'null') ^
                      (form_user.url_image !== null)
                  "
                  :src="form_user.url_image"
                  class="mb-4 bg-light d-flex justify-content-center align-items-center border w-75 rounded-lg shadow-sm"
                />
              </div>

              <div class="col-xl-12 col-md-8 col-12 pt-1">
                <form class="row d-flex justify-content-center">
                  <div class="form-group p-1 col-6 mb-1">
                    <label for="firstName">Nombre</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="firstName"
                      v-model="form_user.first_name"
                      required
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                    />
                  </div>
                  <div class="form-group p-1 col-6 mb-1">
                    <label for="lastName">Apellido</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="lastName"
                      v-model="form_user.last_name"
                      required
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                    />
                  </div>
                  <div class="form-group col-12 p-1 col-md-6 col-lg-12 mb-1">
                    <label for="userEmail">Email</label>
                    <input
                      type="email"
                      class="form-control input-sm"
                      id="userEmail"
                      v-model="form_user.email"
                      required
                    />
                  </div>
                  <div class="form-group col-12 p-1 col-md-6 col-lg-12 mb-3">
                    <label for="typeStatus">Estado del Agremiado</label>
                    <Multiselect
                      v-model="form_user.id_type_user_status"
                      :options="typesUserStatus"
                      label="name"
                      placeholder="Seleccione una Opción"
                      id="typeStatus"
                    ></Multiselect>
                  </div>
                  <div class="form-group col-12 p-1 col-md-6 col-lg-12 mb-3">
                    <div class="w-100 d-flex justify-content-between">
                      <label for="isPublic">Agregar al directorio</label>
                      <input
                        type="checkbox"
                        id="isPublic"
                        v-model="form_user.is_public"
                        @change="
                          form_user.is_public = form_user.is_public ? 1 : 0
                        "
                      />
                    </div>
                  </div>
                  <button
                    class="btn btn-primary btn-fill"
                    type="button"
                    @click.prevent="updateUser()"
                  >
                    Actualizar usuario
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="form-group col-12 p-1 mb-1">
                <label for="password">Contraseña</label>

                <div class="input-group mb-3">
                  <input
                    :type="inputType"
                    class="form-control input-sm"
                    placeholder="Ingrese su contraseña"
                    aria-label="Password"
                    :class="{ 'border-danger': isPasswordMismatch }"
                    id="password"
                    v-model="form_user.password"
                    @input="checkPassword()"
                    required
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-fill btn-secondary border border-secondary p-0 pl-2 pr-2"
                      type="button"
                      @click.prevent="toggleVisibility()"
                    >
                      <i :class="passwordIconClass"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group col-12 p-1 mb-1">
                <label for="password2">Confirmar contraseña</label>

                <div class="input-group mb-3">
                  <input
                    :type="inputType"
                    class="form-control input-sm"
                    placeholder="Confirme su contraseña"
                    aria-label="Confirm Password"
                    :class="{ 'border-danger': isPasswordMismatch }"
                    id="password2"
                    v-model="password2"
                    @input="checkPassword()"
                    required
                  />
                  <div class="input-group-append">
                    <button
                      class="btn btn-fill btn-secondary border border-secondary p-0 pl-2 pr-2"
                      type="button"
                      @click.prevent="toggleVisibility()"
                    >
                      <i :class="passwordIconClass"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="form-group col-12 p-1 mb-1 d-flex justify-content-center"
              >
                <button
                  class="btn btn-primary btn-fill"
                  type="button"
                  @click.prevent="updateUser()"
                >
                  Actualizar contraseña
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- password card end-->
        <div class="col-xl-9">
          <div class="card">
            <div
              class="card-header border-bottom p-2 d-flex justify-content-between overflow-auto"
            >
              <div class="btn-group btn-group-toggle" data-toggle="buttons">
                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'general' }"
                  @click="selectedView = 'general'"
                >
                  Datos generales
                </button>

                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'balance' }"
                  @click="selectedView = 'balance'"
                >
                  Balance
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'documents' }"
                  @click="selectedView = 'documents'"
                >
                  Documentos
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'additional documents' }"
                  @click="selectedView = 'additional documents'"
                >
                  Documentos Adicionales
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'contract' }"
                  @click="selectedView = 'contract'"
                >
                  Carta de agremiado
                </button>
              </div>
              <button
                class="btn btn-primary btn-sm active ml-3"
                :class="{ active: selectedView === 'balance' }"
                @click="returnUrl"
              >
                Volver
              </button>
            </div>
            <div class="card-body">
              <!-- Conditionally render the components based on the selected view -->
              <member-data v-if="selectedView === 'general'" />
              <member-docs v-if="selectedView === 'documents'" />
              <member-additional-docs
                v-if="selectedView === 'additional documents'"
              />
              <member-balance
                v-if="selectedView === 'balance'"
                :id_user_balance="id_user_balance"
                :id_company="form_user && form_user.id_company ? form_user.id_company : null"
                :title="'Balance'"
              />
              <member-contract
                v-if="selectedView === 'contract'"
                :id_user_contract="id_user_contract"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberDocs from './MemberDocs.vue'
import MemberAdditionalDocs from './MemberAdditionalDocs.vue'
import MemberData from './MemberData.vue'
import MemberMonthlyPaymentsReceived from '../../pages/Monthly/MemberMonthlyPaymentsReceived.vue'
import UserContract from '../../pages/Variables/UserContract.vue'
import { mapActions } from 'vuex'

// Import MultiSelect
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// Import SweetAlert2
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      selectedView: 'general', // Default view
      id_user_balance: this.$route.params.id,
      id_user_contract: this.$route.params.id,
      password2: '',
      form_user: {
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        id_company: '',
        id_type_user_status: {},
        password: '',
        is_public: 0,

        // company image
        url_image: ''
      },
      typesUserStatus: [],
      isPasswordMismatch: false,
      inputType: 'password'
    }
  },
  components: {
    Multiselect,
    MemberDocs,
    MemberAdditionalDocs,
    MemberData,
    MemberBalance: MemberMonthlyPaymentsReceived,
    MemberContract: UserContract
  },
  methods: {
    ...mapActions(['getData', 'updateData']),
    loadTypesUserStatus() {
      const form = {
        url: 'type_user_status/all'
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typesUserStatus = response.data.map((item) => {
              return {
                id: item.id,
                name: item.name
              }
            })
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async loadUser(id) {
      const form = {
        url: 'user/' + id
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.form_user = {
              ...response.data,
              id_type_user_status: {
                id: response.data.type_user_status.id,
                name: response.data.type_user_status.name
              }
            }
            console.log('ID Company:', this.form_user.id_company);
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    updateUser() {
      if (this.isPasswordMismatch) {
        Swal.fire({
          title: 'Error',
          text: 'Las contraseñas no coinciden',
          icon: 'error',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      if (this.form_user.password && this.form_user.password.length < 6) {
        Swal.fire({
          title: 'Error',
          text: 'La contraseña debe tener al menos 6 caracteres',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
        return
      }
      if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          this.form_user.email
        )
      ) {
        Swal.fire({
          title: 'Error',
          text: 'El correo electrónico no tiene un formato válido',
          icon: 'error',

          confirmButtonText: 'Aceptar'
        })
        return
      }

      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de modificar los datos de este usuario?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, guardar'
      }).then(async (result) => {
        if (result.value) {
          const form = {
            url: 'user/update',
            id: this.form_user.id,
            data: {
              first_name: this.form_user.first_name,
              last_name: this.form_user.last_name,
              email: this.form_user.email,
              password: this.form_user.password,
              id_type_user_status: this.form_user.id_type_user_status.id,
              is_public: this.form_user.is_public
            }
          }

          await this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Usuario modificado correctamente',
                  icon: 'success',

                  confirmButtonText: 'Aceptar'
                }).then(() => {
                  this.loadUser(this.$route.params.id)
                  this.form_user.password = ''
                  this.password2 = ''
                })
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',

                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },
    returnUrl() {
      this.$router.go(-1)
    },
    checkPassword() {
      this.isPasswordMismatch =
        this.password2 === '' || this.form_user.password !== this.password2
    },
    toggleVisibility() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password'
    }
  },
  async mounted() {
    await this.loadUser(this.$route.params.id)
    await this.loadTypesUserStatus()
  },
  computed: {
    passwordIconClass() {
      return this.inputType === 'password'
        ? 'bi bi-eye-slash fs-5'
        : 'bi bi-eye-fill fs-5'
    },
    confirmPasswordIconClass() {
      return this.inputType === 'password'
        ? 'bi bi-eye-slashfs-5'
        : 'bi bi-eye-fill fs-5'
    }
  }
}
</script>

<style></style>
